import React, { PureComponent } from 'react';
import {
  StyleSheet, View, Text, Image,
  SafeAreaView,
} from 'react-native';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Logger } from '../../../../utils/Logger';
import { defaultScale } from '../../../../utils/scaling';
import { getNextStep, navigateToNextStep } from '../../../actions';
import { IAppStore } from '../../../../HomeWorkouts';
import { GoogleAnalytics } from '../../../../services/google-analytics';
import Theme from '../../../../theme';
import { UserDataConsumer } from '../../../../utils';
import GarminWatchImage from '../../../../assets/images/garmin-watch.png';
import GreenCheckMark from '../../../../assets/icons/check-circle-green.svg';
import { IConnectedAppOnboardingProps, navigateToNextOnboardingStep } from '../ConnectedAppEntryPointScreen';
import FooterButtons from '../shared/FooterButtons';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Theme.WHITE,
    paddingVertical: defaultScale(16),
  },
  headerContainer: {
    alignItems: 'center',
    marginTop: '10%',
    textAlign: 'center',
    flex: 1,
  },
  heading: {
    textAlign: 'center',
    color: Theme.GREEN,
    marginLeft: defaultScale(10),
  },
  garminConnectIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: defaultScale(30),
  },
  subHeader: {
    marginTop: defaultScale(40),
    color: Theme.GREY_DARK_MEDIUM,
    paddingHorizontal: defaultScale(30),
    textAlign: 'center',
  },
});

class GarminConnectSyncEnabled extends PureComponent<IConnectedAppOnboardingProps & WithTranslation> {
  private readonly googleAnalytics: GoogleAnalytics;

  public constructor(props: IConnectedAppOnboardingProps & WithTranslation) {
    super(props);
    this.googleAnalytics = new GoogleAnalytics();
  }

  public render() {
    const { t } = this.props;

    return (
      <SafeAreaView style={styles.container}>
        <View style={styles.headerContainer}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <GreenCheckMark />
            <Text style={[Theme.textStyle.heading, styles.heading]}>{t('garminConnectSyncEnabled')}</Text>
          </View>
          <View style={styles.garminConnectIcon}>
            <Image
              source={GarminWatchImage}
              onError={(err) => Logger.notify(JSON.stringify(err))}
              style={{ width: defaultScale(150), height: defaultScale(150), marginTop: defaultScale(30) }}
            />
          </View>
          <Text style={[Theme.textStyle.bodyCopyReg, styles.subHeader]}>
            {t('garminWatchActivity')}
          </Text>
        </View>
        <FooterButtons
          primaryButtonText={t('next')}
          onPrimaryButtonPress={() => this.proceedToNextStep()}
          isLoading={false}
        />
      </SafeAreaView>
    );
  }

  private proceedToNextStep = () => {
    navigateToNextOnboardingStep(
      this.props,
      this.props.getNextStep,
      this.props.navigateToNextStep,
    );
    this.googleAnalytics.logEventWithParamaters('sign_up_garmin_sync_enabled_proceed', { enabled: true });
  };
}

const mapStateToProps = (state: IAppStore) => ({
  enabledFeatures: state.auth.signup.enabledFeatures,
});

const mapDispatchToProps = {
  getNextStep,
  navigateToNextStep,
};

export default withTranslation(['auth', 'settings'])(
  connect(mapStateToProps, mapDispatchToProps)(UserDataConsumer(GarminConnectSyncEnabled)),
);
